const SLA_CONFIG_KEY = 'amc_sla_config_v1';

export const DEFAULT_SLA_HOURS = 48;

const normalizeHours = (value, fallback = DEFAULT_SLA_HOURS) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed) || parsed <= 0) {
    return fallback;
  }
  return parsed;
};

export const getSlaHours = () => {
  if (typeof window === 'undefined') {
    return DEFAULT_SLA_HOURS;
  }

  try {
    const raw = window.localStorage.getItem(SLA_CONFIG_KEY);
    if (!raw) {
      return DEFAULT_SLA_HOURS;
    }

    const parsed = JSON.parse(raw);
    if (typeof parsed === 'object' && parsed !== null && 'hours' in parsed) {
      return normalizeHours(parsed.hours);
    }

    // Backward compatibility for old per-priority config.
    if (typeof parsed === 'object' && parsed !== null) {
      return normalizeHours(parsed.NORMAL ?? parsed.HIGH ?? parsed.CRITICAL ?? parsed.LOW);
    }

    return normalizeHours(parsed);
  } catch (_error) {
    return DEFAULT_SLA_HOURS;
  }
};

export const saveSlaHours = (hours) => {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.setItem(SLA_CONFIG_KEY, JSON.stringify({ hours: normalizeHours(hours) }));
};

export const getSlaHoursByPriority = () => {
  return getSlaHours();
};

export const getSlaPlanLabel = (priority) => {
  const hours = getSlaHoursByPriority(priority);
  return `${hours} Hour Response`;
};
